export default "/static/images/network.png"